import React from "react";
import Bg from "../common/Bg";
import { Link } from "react-router-dom";
const Header = () => {
    return (
        <React.Fragment>
            <header>
                <Bg />

                {/* <a href="" className="logo">
                    <img src="images/logo.png" />
                </a> */}
                <h1> با اساتید مجرب و کار آزموده در خودآموز ماه کورس </h1>
                <h2> آموزش ببینید ، تجربه کسب کنید و بازار کار شوید </h2>
                <h3> با کمترین هزینه خودت یاد بگیر </h3>
            </header>
            <div className="search-form">
                <form>
                    <Link to="/archive">
                        <input
                            style={{ padding: "0px", boxShadow: ' 3px 5px 9px black,-3px -5px 9px black' }}
                            type="button"
                            name=""
                            value="مشاهده همه ی دوره ها"
                        />
                    </Link>

                </form>
            </div>
        </React.Fragment>
    );
};

export default Header;
